import { useCallback, useEffect, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import { usePlanAccess } from "../../../hooks/usePlanAccess";
import { Button, useToast } from "../../ui";
import s from "./clientApp.module.css";

const LABELS = {
  telegram: "Telegram",
  max: "Max",
};

export default function ClientMessengerSettings() {
  const toast = useToast();
  const plan = usePlanAccess();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(null);
  const [codes, setCodes] = useState({});

  const load = useCallback(() => {
    if (!plan.messengers) return;
    clinicAPI
      .getMyMessengerLinks()
      .then(setData)
      .catch(() => setData({ links: [], messengers: [] }));
  }, [plan.messengers]);

  useEffect(() => {
    load();
  }, [load]);

  if (!plan.messengers) return null;

  const messengers = data?.messengers || [];
  if (!messengers.length && !data) {
    return <p className={s.profileMuted}>Загрузка мессенджеров…</p>;
  }
  if (!messengers.length) {
    return (
      <p className={s.profileMuted}>
        Клуб ещё не подключил бота Telegram или Max. Когда подключит — здесь
        появится привязка.
      </p>
    );
  }

  const linked = new Set((data?.links || []).map((l) => l.provider));

  const requestCode = async (provider) => {
    setBusy(provider);
    try {
      const res = await clinicAPI.createMessengerLinkCode(provider);
      setCodes((prev) => ({ ...prev, [provider]: res }));
      toast.success("Код создан");
    } catch (e) {
      toast.error(e.response?.data?.error || e.message || "Ошибка");
    } finally {
      setBusy(null);
    }
  };

  return (
    <div>
      <p className={s.profileMuted}>
        Привяжите мессенджер, чтобы получать напоминания о тренировках и
        отвечать «Приду» прямо в боте.
      </p>
      {messengers.map((m) => {
        const provider = m.provider;
        const isLinked = linked.has(provider);
        const codeInfo = codes[provider];
        return (
          <div key={provider} style={{ marginBottom: 16 }}>
            <p style={{ margin: "0 0 6px", fontWeight: 600 }}>
              {LABELS[provider] || provider}
              {isLinked ? " · привязан" : ""}
            </p>
            {codeInfo?.code ? (
              <div className={s.profileMuted}>
                <p>
                  Код: <strong>{codeInfo.code}</strong>
                </p>
                {codeInfo.deep_link ? (
                  <p>
                    <a href={codeInfo.deep_link} target="_blank" rel="noreferrer">
                      Открыть бота и привязать
                    </a>
                  </p>
                ) : (
                  <p>
                    Напишите боту @{String(codeInfo.bot_username || "").replace(/^@/, "")}{" "}
                    код или /start link_{codeInfo.code}
                  </p>
                )}
              </div>
            ) : null}
            <Button
              type="button"
              size="sm"
              variant={isLinked ? "secondary" : "primary"}
              disabled={busy === provider}
              onClick={() => requestCode(provider)}
            >
              {busy === provider
                ? "…"
                : isLinked
                  ? "Новый код привязки"
                  : `Привязать ${LABELS[provider] || provider}`}
            </Button>
          </div>
        );
      })}
    </div>
  );
}
